import { Spacer } from "shared/layout";
import { CenterContent } from "shared/styles";
import { ContentWidth } from "shared/styles/constants";

import { CustomSubscriptionsRequestsTable, BandsTable } from "./containers";

export const AdminDashboard = () => {
  return (
    <CenterContent width={ContentWidth.wide}>
      <Spacer size="l">
        <CustomSubscriptionsRequestsTable />
        <BandsTable />
      </Spacer>
    </CenterContent>
  );
};
